import React from 'react'

const InputField = ({ label, name, value, onChange, error }) => (
  <div>
    <label className="block text-sm font-medium text-gray-700">{label} *</label>
    <input
      name={name}
      value={value}
      onChange={onChange}
      className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3"
    />
    {error && <p className="mt-1 text-sm text-red-600">{error}</p>}
  </div>
);


export default InputField